module.exports = __webpack_public_path__ + "img/biglogo.d7986c17.jpg";